import { groupBy } from 'lodash'
import {
  APP_ID_LOGGING_SERVICE, APP_ID_PAN_CHINA,
  APP_ID_PANORAMA,
  APP_ID_PRISMA_ACCESS_EDITION,
  APP_ID_SDWAN,
  APP_ID_SUPPORT,
  LICENSE_TYPE_FED_HIGH,
  LICENSE_TYPE_FED_MOD,
  APP_ID_FEDRAMP,
} from '../constants/GlobalConstants'
import { APP_ID_TO_NAME } from '../constants/LabelConstants'
import {
  FF_ENABLE_IOT,
  FF_ENABLE_OKYO,
  FF_ENABLE_SASS,
  FF_MULTI_DLP,
  FF_FEDRAMP_HIGH,
  FF_FEDRAMP_MOD,
  FF_COMMERCIAL,
} from '../utils/FeatureFlags'
import { getVarValue } from '../utils/Sparky'
import { isNonemptyArray } from '../utils/Utils'
import {
  LOAD_LICENSE,
  LOAD_CSP_ACCOUNTS,
  LOAD_LICENSE_INSTANCES,
  SET_ACTIVATE_LOADING, LOAD_USER_INSTANCES, SET_NEW_TSG_LOADING, SET_USER_FLOW, SET_USER_MESSAGE, MERGE_USER_CSP_ACCOUNT
} from './actions/LicenseReducer.actions'
import {
  BLOCK_CLAIM_APPS,
  CLAIM, CLAIM_DISABLE_NO_LOGGING_SERVICE_TOOLTIP, CLAIM_DISABLE_PAN_CHINA_TOOLTIP,
  CLAIM_DISABLE_TOOLTIP,
  UNCLAIM, UPDATE
} from '../../subscription/components/constants/SubscriptionConstant'

const initialState = {
  licenseDetails: [],
  licenseTableFormat: [],
  licenseByKey: [],
  cspAccountDetails: [],
  cspDropDownData: [],
  licenseInstances: [],
  activateLoading: false,
  userInstances: [],
  updatedLicenseInfo: [],
  cgxRootTSGS: [],
  userFlow: '',
  isPanorama: false,
  licenseMessage: '',
  isLicenseError: false,
  newTsgLoading: { newTsg: false, dayZero: false },
  userSupportAccountsInfo: []
}

const LicenseReducer = ((state = initialState, action) => {
  switch (action.type) {
    case LOAD_LICENSE: {
      const { result: licenseTableData, cgxRootTSGS, isPanorama } = formatLicenseTableData(action.licenseDetails ?? [])
      const licenseByKey = groupBy(licenseTableData, 'primary_product_name')
      const updatedLicense = getActionRequiredTenant(action.licenseDetails)
      return {
        ...state,
        licenseDetails: action.licenseDetails,
        licenseTableFormat: licenseTableData,
        cgxRootTSGS,
        licenseByKey: licenseByKey,
        updatedLicenseInfo: updatedLicense,
        isPanorama: isPanorama
      }
    }
    case LOAD_CSP_ACCOUNTS: {
      return {
        ...state,
        cspAccountDetails: action.cspResponse,
        cspDropDownData: cspDropDownFormatter(action.cspResponse, action.isFramework)
      }
    }
    case LOAD_LICENSE_INSTANCES: {
      return {
        ...state,
        licenseInstances: action.instanceResponse
      }
    }
    case SET_ACTIVATE_LOADING: {
      return {
        ...state,
        activateLoading: action.loading
      }
    }
    case SET_USER_FLOW: {
      return {
        ...state,
        userFlow: action.userFlow
      }
    }
    case SET_NEW_TSG_LOADING: {
      return {
        ...state,
        newTsgLoading: { newTsg: action.loading.newTsg, dayZero: action.loading.dayZero }
      }
    }
    case LOAD_USER_INSTANCES: {
      return {
        ...state,
        userInstances: action.instances
      }
    }
    case SET_USER_MESSAGE: {
      return {
        ...state,
        isLicenseError: action.isError,
        licenseMessage: action.message
      }
    }
    case MERGE_USER_CSP_ACCOUNT: {
      return {
        ...state,
        userSupportAccountsInfo: action.userCSPAccounts
      }
    }
    default: {
      return state
    }
  }
})
const cspDropDownFormatter = (cspDetails, isFrameWork) => {
  const fedHighEnv = getVarValue(FF_FEDRAMP_HIGH, false)
  const result = []
  let _cspDetails
  if (fedHighEnv) {
    _cspDetails = cspDetails
  }
  else {
    _cspDetails = cspDetails?.filter(({ is_federal }) => !is_federal)
  }
  _cspDetails?.forEach((elem) => {
    if (isFrameWork) {
      const data = {
        value: `${elem.name}-${elem.accountid}`,
        description: elem.name,
        id: elem.accountid,
        children: `${elem.name}-${elem.accountid}`
      }
      result.push(data)
    }
    else {
      const data = {
        value: `${elem.support_account_name}-${elem.support_account_id}`,
        description: elem.support_account_name,
        id: elem.support_account_id,
        children: `${elem.support_account_name}-${elem.support_account_id}`,
      }
      result.push(data)
    }
  })
  return result
}

const getDateFormat = (dateValue) => {
  const [year, month, day] = dateValue.split('-')
  return `${month}/${day.slice(0, 2)}/${year}`
}
const getActionRequiredTenant = ((licenseDetails) => {
  const response = []
  if (isNonemptyArray(licenseDetails)) {
    licenseDetails?.forEach((elem) => {
      elem?.associated_tenant?.length > 0 && elem.associated_tenant?.forEach((each) => {
        if (each?.pending_upgrade) {
          response.push(each?.tsg_id)
        }
      })
    })
  }
  return response
})
const formatLicenseTableData = (licenseDetails) => {
  const enableFF = []
  const cgxRootTSGS = []
  getVarValue(FF_ENABLE_OKYO, false) && enableFF.push('okyo')
  getVarValue(FF_MULTI_DLP, false) && enableFF.push('dlp')
  getVarValue(FF_ENABLE_IOT, false) && enableFF.push('zingbox')
  getVarValue(FF_ENABLE_SASS, false) && enableFF.push('aperture')
  const blockedApps = BLOCK_CLAIM_APPS.filter((item) => {
    return !enableFF.includes(item)
  })
  const result = []
  let id = 0
  let headerId = 0
  let isPanorama = false
  if (isNonemptyArray(licenseDetails)) {
    licenseDetails?.sort((item1, item2) => new Date(item2.claim_at) - new Date(item1.claim_at))
    licenseDetails?.sort((item1, item2) => (item1.pending_amend ? -1 : item2.pending_amend ? 1 : 0))
    licenseDetails.forEach((each, index) => {
      const licenseInformation = each?.licenses?.filter((elem) =>
        (elem.app_id !== APP_ID_PRISMA_ACCESS_EDITION && elem.app_id !== APP_ID_SDWAN))
      let appName = ''
      if (!isPanorama && licenseInformation?.some(({ app_id }) => app_id === APP_ID_PANORAMA) && !each.is_claimed) {
        isPanorama = true
      }
      each?.licenses?.forEach((element, idx) => {
        if (element.app_id === APP_ID_PRISMA_ACCESS_EDITION || element.app_id === APP_ID_SDWAN) {
          if (element.app_id === APP_ID_SDWAN || element?.entitlements?.some(each => each.app_id === APP_ID_SDWAN)) {
            element.tsg_id && cgxRootTSGS.push(element.tsg_id)
          }
          const primaryProduct = element.app_id.concat(':', index)
          const license_start = element.issue_date ? getDateFormat(element.issue_date) : ' '
          const license_end = element.license_expiration ? getDateFormat(element.license_expiration) : ' '
          const serialNumber = element.serial_number && each.is_claimed ? element.serial_number : ' '
          let claimDisabled = false
          let evalLicense = false
          element.entitlements?.forEach((each) => {
            if (blockedApps.includes(each.app_id)) {
              claimDisabled = true
              if (each.app_id === APP_ID_PAN_CHINA) {
                appName = `${APP_ID_TO_NAME[each.app_id]} ${CLAIM_DISABLE_PAN_CHINA_TOOLTIP}`
              }
              else {
                appName = !each.license_display_name ? each.app_id : `${each.license_display_name} ${CLAIM_DISABLE_TOOLTIP}`
              }
            }
            if (each.license_type?.includes('EVAL')) {
              evalLicense = true
            }
          })
          if (element.app_id === APP_ID_PRISMA_ACCESS_EDITION) {
            const fedHighEnv = getVarValue(FF_FEDRAMP_HIGH, false)
            const fedModEnv = getVarValue(FF_FEDRAMP_MOD, true)
            const commerceEnv = getVarValue(FF_COMMERCIAL, true)
            // fedramp related
            const fedrampAddon = element.entitlements?.find(each => each.app_id === APP_ID_FEDRAMP)
            if (fedrampAddon) {
              // fed high magic link, but not fed high supported env
              if (fedrampAddon.license_type.toUpperCase() === LICENSE_TYPE_FED_HIGH && !fedHighEnv) {
                claimDisabled = true
                appName = 'You are opening an activation that\'s not supported in this environment'
              }
              // fed mod magic link, but not fed mod supported env
              if (fedrampAddon.license_type.toUpperCase() === LICENSE_TYPE_FED_MOD && !fedModEnv) {
                claimDisabled = true
                appName = 'You are opening an activation that\'s not supported in this environment'
              }
            }
            else if (!commerceEnv) {
              claimDisabled = true
              appName = 'You are opening an activation that\'s not supported in this environment'
            }
          }
          //To Validate is Logging Service is available during the claim
          if (!each?.is_upgrade && element.app_id === APP_ID_PRISMA_ACCESS_EDITION) {
            const loggingService = each?.licenses.find((elem) => elem.app_id === APP_ID_LOGGING_SERVICE)
            if (!loggingService || loggingService.is_csp_activated) {
              claimDisabled = true
              appName = CLAIM_DISABLE_NO_LOGGING_SERVICE_TOOLTIP
            }
          }
          const licenseGrouping = {
            'is_header': true,
            'id': id++,
            'headerId': headerId++,
            'primary_product_name': primaryProduct,
            'product_desc': 'Prisma SASE',
            'product_name': 'Prisma SASE',
            'isEval': evalLicense,
            'auth_code': element.auth_code,
            'hash': each.hash,
            'claimed_by_tenant': element.tsg_id,
            'contract': serialNumber,
            'associated_tenant': each.associated_tenant,
            'image_name': element.app_id,
            'actions': each.is_claimed && each.pending_amend ? UPDATE : each.is_claimed ? UNCLAIM : CLAIM,
            'pending_hash': each.pending_amend,
            'allocation_type': element.allocation_type,
            'license_id': element.license_id,
            'tsg_id': element.tsg_id,
            'start_date': license_start,
            'support_account_id': element.support_account_id,
            'end_date': license_end,
            'locked_tsg': element.locked_tsg ?? '',
            'block_claim': claimDisabled ? appName : false,
            'start_date_search': license_start,
            'end_date_search': license_end,
          }
          result.push(licenseGrouping)
          const license = {
            'is_primary': true,
            'is_collapsed': true,
            'id': id++,
            'auth_code': element.auth_code,
            'hash': element.hash,
            'pending_hash': each.pending_amend,
            'support_account_id': element.support_account_id,
            'count_of_addons': element.entitlements ? element.entitlements.length + licenseInformation?.length : 0,
            'primary_product_name': primaryProduct.concat('.', idx),
            // TODO: REMOVE APP_ID_TO_NAME
            'product_desc': element.license_display_name ?? element.application_display_name ?? APP_ID_TO_NAME[element.app_id] ?? element.app_id,
            'app_id': element.app_id,
            //'product_desc': APP_ID_TO_NAME[element.app_id] ?? element.app_id,
            'product_name': element.app_id,
            'status': each.is_claimed ? 'Claimed' : 'UnClaimed',
            'license_id': element.license_id,
            'tsg_id': element.tsg_id,
            'quantity': '',
            'contract': serialNumber,
            'claimed_by_tenant': element.tsg_id,
            //'associated_tenant': each.associated_tenant,
            'claim_required': each.claim_required,
            'start_date_search': license_start,
            'end_date_search': license_end,
            'start_date': '',
            'end_date': '',
            'actions': each.is_claimed ? UNCLAIM : CLAIM
          }
          result.push(license)
          element.entitlements?.forEach((entitlement) => {
            const products = {
              'primary_product_name': primaryProduct.concat('.', idx),
              'product_desc': entitlement.license_display_name ?? entitlement.app_id,
              'app_id': entitlement.app_id,
              'id': id++,
              //'product_desc': APP_ID_TO_NAME[entitlement.app_id] ?? entitlement.app_id,
              //'product_desc': appName,
              'product_name': element.app_id,
              'status': each.is_claimed ? 'Claimed' : 'UnClaimed',
              'quantity': entitlement.purchased_size,
              'license_id': element.license_id,
              'tsg_id': element.tsg_id,
              'contract': serialNumber,
              'claimed_by_tenant': element.tsg_id,
              //'associated_tenant': each.associated_tenant,
              'start_date': '',
              'end_date': '',
              'start_date_search': license_start,
              'end_date_search': license_end,
              'actions': each.is_claimed ? UNCLAIM : CLAIM
            }
            result.push(products)
          })
          const isSupport = licenseInformation.some(each => each.app_id === APP_ID_SUPPORT)
          const isPanoroma = licenseInformation.some(each => each.app_id === APP_ID_PANORAMA)
          const filteredLicenseInfo = licenseInformation.filter((support) => {
            return isSupport && isPanoroma ? support.app_id !== APP_ID_SUPPORT : support
          })
          filteredLicenseInfo.length > 0 && filteredLicenseInfo.forEach((cdl) => {
            const products = {
              'primary_product_name': primaryProduct.concat('.', idx),
              'product_desc': (isSupport && isPanoroma && cdl.app_id === APP_ID_PANORAMA) ? 'Panorama with Support' : cdl.app_id,
              'product_name': element.app_id,
              'id': id++,
              'app_id': cdl.app_id,
              'claimed_by_tenant': element.tsg_id,
              'license_id': element.license_id,
              'tsg_id': element.tsg_id,
              //'associated_tenant': each.associated_tenant,
              'status': each.is_claimed ? 'Claimed' : 'UnClaimed',
              'quantity': (cdl.entitlements && cdl.entitlements.length) ? cdl.entitlements[0].purchased_size : 0,
              'contract': serialNumber,
              'start_date': '',
              'end_date': '',
              'start_date_search': license_start,
              'end_date_search': license_end,
              'actions': each.is_claimed ? UNCLAIM : CLAIM
            }
            result.push(products)
          })
        }
      })
    })
    return { result, cgxRootTSGS, isPanorama }
  }
  else {
    return { result: [], cgxRootTSGS: [], isPanorama }
  }
}
LicenseReducer.initialState = initialState
export default LicenseReducer
